import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_memu3px42g: FaireBrandEntity = {
  token: "b_memu3px42g",
  type: "brand",
  name: "Serangoon Market",
  avatarUrl:
    "https://cdn.faire.com/fastly/117556d0d6bc7c33d3fad7196e25eacf8160d52d22ee4f190f649e792940433c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dd019450ee994f1c442cd63bbbb684fe9f2decb86864d365a6886a469367c153.png",
  logoUrl:
    "https://cdn.faire.com/fastly/117556d0d6bc7c33d3fad7196e25eacf8160d52d22ee4f190f649e792940433c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dd019450ee994f1c442cd63bbbb684fe9f2decb86864d365a6886a469367c153.png",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 50,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Rediscovering our love for cooking while living in Singapore, a vibrant melting pot of cultures and cuisines, was a turning point for us. As we dove into grilling, smoking, and air-frying, we realized that the BBQ aisle was missing something crucial—global flavors. Despite BBQ being a tradition in so many cultures around the world, it wasn't well-represented.\n\nAs ethnic Indian Americans, we felt the need to bridge that gap. That’s how Serangoon Market was born—a brand dedicated to creating simple, easy-to-use solutions that bring these diverse, rich flavors straight to your dinner table.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:50.062Z",
    importedBy: "entity-db-cli",
  },
};
